import {
	Accordion,
	GeneticsIcon,
	ToggleGroup,
} from "@au-schein-de/au-ui-library";
import { GENETICS_OPTIONS_MAP } from "@dransay/api/models";
import { useTranslation } from "react-i18next";
import { FilterHeader } from "../filter-header.component";
import { useFiltersContext } from "../filters.context";
import type { FiltersState } from "../types";

type Genetics = NonNullable<FiltersState["genetics"]>;
type Genetic = Genetics[number];

export function GeneticsFilter() {
	const { t } = useTranslation("product");
	const { filters, onFilterChange, facets } = useFiltersContext();
	const selected = filters.genetics ?? [];
	const facetCounts = facets?.genetics;

	const getCount = (genetic: string): number | undefined => {
		if (!facetCounts?.length) return undefined;
		return facetCounts.find((f) => f.value === genetic)?.count ?? 0;
	};

	const handleChange = (values: string[]) => {
		onFilterChange(
			"genetics",
			values.length ? (values as Genetics) : undefined,
		);
	};

	return (
		<Accordion.Item
			value="genetics"
			variant="filter"
			data-testid="genetics-filter"
		>
			<Accordion.Trigger variant="filter" data-testid="genetics-filter-trigger">
				<FilterHeader
					title={t("filters.genetics")}
					value={selected.length}
					icon={<GeneticsIcon size={5} />}
				/>
			</Accordion.Trigger>
			<Accordion.Content variant="filter">
				<ToggleGroup.Root
					type="multiple"
					variant="secondary"
					size="xs"
					className="flex-wrap justify-start gap-2"
					value={selected}
					onValueChange={handleChange}
				>
					{Object.entries(GENETICS_OPTIONS_MAP).map(([genetic, label]) => {
						const isSelected = selected.includes(genetic as Genetic);
						const count = getCount(genetic);
						const isDisabled = count === 0 && !isSelected;
						return (
							<ToggleGroup.Item
								key={genetic}
								value={genetic}
								disabled={isDisabled}
							>
								{label}
							</ToggleGroup.Item>
						);
					})}
				</ToggleGroup.Root>
			</Accordion.Content>
		</Accordion.Item>
	);
}
